import * as React from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import { navigate } from 'gatsby';
import ComfortIcons from './ComfortIcons';

function ActionForm({ stacked, landing, heading, pages, comfortList }) {
  return (
    <>
      {landing ? (
        <h2>{heading}</h2>
      ) : (
        <h3 style={{ color: '#fff' }}>{heading}</h3>
      )}

      <form style={{ position: 'relative', textAlign: 'center' }}>
        <ToggleButtonGroup type='radio' name='pages'>
          {pages.map((page) => (
            <ToggleButton
              key={page.slug}
              className={stacked ? 'block' : ''}
              onClick={() =>
                navigate(`/${page.slug}${!landing ? '#header' : ''}`)
              }
            >
              {page.title}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </form>
      <hr />
      <ComfortIcons list={comfortList} fontColor={landing ? '000' : 'fff'} />
    </>
  );
}
export default ActionForm;
